<!-- Toolbar -->
<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
  style="top: 94px"
>
<div
*ngIf="viewSelect"
class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
>
<mat-form-field appearance="fill">
  <mat-label>Select customer</mat-label>
  <mat-select
    (selectionChange)="OnChangeNewCustomer($event.value)"
    [(ngModel)]="idcustomer"
  >
    <mat-option
      *ngFor="let item of multipleCustomers"
      [value]="item.tblCustomerId"
      >{{ item.customerName }}</mat-option
    >
  </mat-select>
</mat-form-field>
</div>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    *ngIf="graficas"
  >
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <h3 style="font-size: 17px">Pending Orders</h3>
      <div class="chart-wrapper">
        <canvas
          baseChart
          [datasets]="barChartData"
          [labels]="barChartLabels"
          [options]="barChartOptions"
          [plugins]="barChartPlugins"
          [legend]="barChartLegend"
          [chartType]="barChartType"
        >
        </canvas>
      </div>
    </div>
    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <h3 style="font-size: 17px">Today's Completed Orders</h3>
      <div class="chart-wrapper">
        <canvas
          baseChart
          [datasets]="Today"
          [labels]="barChartLabels"
          [options]="barChartOptions"
          [plugins]="barChartPlugins"
          [legend]="barChartLegend"
          [chartType]="barChartType"
          style="display: block; width: 1229px; height: 314px"
        >
        </canvas>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" *ngIf="false">
      <h3 style="font-size: 17px">Company Yearly Orders Activity</h3>
      <div class="chart-wrapper">
        <canvas
          baseChart
          [datasets]="yearly"
          [labels]="barChartLabels"
          [options]="barChartOptions"
          [plugins]="barChartPlugins"
          [legend]="barChartLegend"
          [chartType]="barChartType"
          style="display: block; width: 1229px; height: 314px"
        >
        </canvas>
      </div>
    </div>
  </div>
  <div
    class="
      col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
      justify-content-center
    "
    *ngIf="!graficas"
    style="text-align: center"
  >
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <img style="text-align: center" src="../../../assets/3plfs.png" alt="" />
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
></ngx-spinner>
